/* import __COLOCATED_TEMPLATE__ from './translate-conversation-tooltip.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

interface Signature {
  Args: {
    dynamicArgs: {
      isLimitReached: boolean;
      quota: {
        used: number;
        available: number;
      };
    };
  };
}

export default class TranslateConversationTooltip extends Component<Signature> {
  @service declare session: $TSFixMe;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::TranslateConversationTooltip': typeof TranslateConversationTooltip;
    'inbox2/translate-conversation-tooltip': typeof TranslateConversationTooltip;
  }
}
